import React from 'react'
import classnames from 'classnames';
import PropTypes from 'prop-types'
import './Badges.scss'
import HrbTranslate from '../../language/HrbTranslate';

const PresaleStatusBadge = props => {

    const { status, className } = props

    return (
        <div className={classnames('status-badge', status.split(' ').join('').toLowerCase(), className)}>            
            {status.toLowerCase() === 'success' &&
                <HrbTranslate text='ReturnInfo.Labels.Success' />
            }
            {status.toLowerCase() === 'card failure' &&
                <HrbTranslate text='ReturnInfo.Labels.CardFailure' />
            }
            {status.toLowerCase() === 'available' &&
                <HrbTranslate text={'PresaleInfo.Status.Available'} />
            }
            {status.toLowerCase() === 'redeemed' &&
                <HrbTranslate text={'PresaleInfo.Status.Redeemed'} />
            }            
        </div>)
}

PresaleStatusBadge.propTypes = {
    workflowTask: PropTypes.string,
    status: PropTypes.string.isRequired,
    className: PropTypes.string
}

export default PresaleStatusBadge